import { AxiosPromise, AxiosStatic } from "axios";
import {
  DealBotQueryResponse,
  DealBotConversationTurn,
} from "../types/DealBot";

export const queryDealBot =
  (serverURL: string, appAxios: AxiosStatic) =>
  (
    dealId: string,
    message: string,
    history?: DealBotConversationTurn[],
    conversationSessionId?: string,
    conversationId?: string
  ): AxiosPromise<DealBotQueryResponse> =>
    appAxios.post(
      `${serverURL}/deals/${dealId}/bot/query`,
      { message, history, conversationSessionId, conversationId },
      {
        withCredentials: true,
      }
    );
